module.exports = __webpack_public_path__ + "media/images/ticketlog-f3d9b7b9e971ce1f63a47fadc87ac637.png";